export default __webpack_public_path__ + "assets/images/play-8625f276b3c126726e7eda27f663e04b.svg";